import React, { Component } from "react";

export default class AdChitika extends Component {
  constructor(props) {
    super(props);

    var width = window.innerWidth;
    var adWidth = 0;
    var adHeight = 0;

    if (window.CHITIKA === undefined) {
      window.CHITIKA = {
        units: []
      };
    };

    if (width < 728 )
    {
      adWidth = 320;
      adHeight = 50;
    } else {
      adWidth = 728;
      adHeight = 90;
    }

    var unit = {
      calltype: "async[2]",
      publisher: this.props.publisher,
      width: adWidth,
      height: adHeight,
      sid: "Chitika Default"
    };

    this.placementId = "chitikaAdBlock-" + window.CHITIKA.units.length;

    window.CHITIKA.units.push(unit);
  }

  componentDidMount() {
  //  const adScript = document.createElement("script");
  //  adScript.type = "text/javascript";
//    adScript.src = "//cdn.chitika.net/getads.js";
  //  adScript.async = true;
  //  this.instance.appendChild(adScript);
  }

  render() {
    var adDivStyle={
      backgroundColor:"white",
      justifyContent: "center"
    }

    return <div id={this.placementId} ref={el => (this.instance = el)} />;
  }
}



// WEBPACK FOOTER //
// ./src/Ads/AdChitika.js